<template>
  <div class="addCardMain common-form-content">
    <el-form
        :model="formData"
        ref="form"
        size="normal"
        :show-message="false"
        :rules="rules">
      <div class="form-content">
        <el-form-item label="卡号" prop="cardNo">
          <el-input
              v-model="formData.cardNo"
              placeholder="请输入卡号"
              maxlength="16"
              :disabled="formData.id ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item label="余额" prop="sum" class="no-required">
          <el-input
              v-model="formData.sum"
              @input="
              formData.sum.length > 5 ? (formData.sum = formData.sum.slice(0, 5)) : formData.sum
            "
              type="number"
              placeholder="请输入余额"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" class="no-required">
          <el-input
              v-model="formData.mobile"
              @click.native="handleClick()"
              placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="代理商" prop="realName">
          <el-select
              v-model="formData.realName"
              placeholder="请选择代理商"
              class="cardSelect"
              style="width: 100%"
              @focus="SelectOperator()"
          >
          </el-select>
        </el-form-item>
      </div>
      <div class="form-sub-box">
        <div class="submit-btn" :class="{'is-submit-state': mixin_submitBtnState}" @click="onSubmit">
          保存
        </div>
      </div>
    </el-form>
    <nut-numberkeyboard
        :visible="visible"
        @input="input"
        @close="close"
        @delete="deleteInput"
    ></nut-numberkeyboard>
    <nut-picker
        :is-visible="showOperatorSelect"
        :list-data="operatorList"
        @close="closePicker"
        @confirm="confirmPicker"
    ></nut-picker>
  </div>
</template>
<script>
import {addCard, editCard, getOperatorSelect} from "@/api/newApi";
import {Toast} from "vant";
import "vant/lib/toast/style/index";
import {validate} from "@/mixins/mixin";

export default {
  components: {},
  mixins: [validate],
  props: {},
  data() {
    var validateCardNo = (rule, value, callback) => {
      var format = /^[a-fA-F0-9]{1,16}$/;
      if (value === "") {
        callback(new Error("请输入卡号(ABCDEF)+数字(0-9)"));
      } else if (!format.test(value)) {
        callback(new Error("请输入卡号(ABCDEF)+数字(0-9)"));
      } else {
        if (value.length !== 16) {
          callback(new Error("请输入16位数卡号"));
        } else {
          callback();
        }
      }
    };
    var validateNum = (rule, value, callback) => {
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (value === "") {
        callback(new Error("请输入"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入合法金额"));
        }
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (value === "") {
        callback(new Error("请输入"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      }
    };
    return {
      visible: false,
      showOperatorSelect: false,
      operatorList: [],
      formData: {
        cardNo: "",
        sum: "",
        mobile: "",
        operator: "",
        realName: "",
        state:"",
      },
      rules: {
        cardNo: [
          {required: true, message: "请输入卡号", trigger: "blur"},
          {validator: validateCardNo, trigger: "blur"},
        ],
        // sum: [
        //   {required: true, message: "请输入余额", trigger: "blur"},
        //   {validator: validateNum, trigger: "blur"},
        // ],
        // mobile: [
        //   {required: true, message: "请输入手机号", trigger: "blur"},
        //   {validator: validatePhone, trigger: "blur"},
        // ],
        realName: [
          {required: true, message: "请选择代理商", trigger: "blur"},
        ],
      
      },
      stateObj: {
        '正常': 6001,
        '挂失': 6002,
        '未启用': 6003,
      }
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getOperatorSelect();
    if (this.$route.query.id) {
      document.title = "编辑卡";
      this.formData = this.$route.query;
      this.formData.state = this.stateObj[this.formData.state];
    } else {
      document.title = "新增卡";
    }
  },
  methods: {
    getOperatorSelect() {
      getOperatorSelect().then((res) => {
        this.operatorList = [
          res.data.map((item) => {
            return {
              label: item.operatorId,
              value: item.operatorNm,
            };
          }),
        ];
      });
    },
    SelectOperator() {
      this.showOperatorSelect = true;
    },
    closePicker() {
      this.showOperatorSelect = false;
    },
    confirmPicker(even) {
      this.formData.realName = even[0].value;
      this.formData.operator = even[0].label;
      this.showOperatorSelect = false;
    },
    handleClick() {
      this.visible = true;
    },
    input(number) {
      this.formData.mobile += number;
    },
    close() {
      this.visible = false;
    },
    deleteInput() {
      if (this.formData.mobile.length > 0) {
        this.formData.mobile = this.formData.mobile.slice(0, -1);
      }
    },
    onSubmit() {
      this.$refs["form"].validate((valid, validObject) => {
        if (valid) {
          if (document.title == "新增卡") {
            addCard({
              ...this.formData,
              deviceType: "4"
            }).then((res) => {
              if (res.message.code == 0) {
                this.$router.replace({
                  path: "/admin/card",
                });
              } else {
                Toast(res.message.message);
              }
            });
          } else {
        
            editCard(this.formData).then((res) => {
         
              if (res.message.code == 0) {
                this.$router.replace({
                  path: "/admin/card",
                });
              } else {
                Toast(res.message.message);
              }
            });
          }
        } else {
          let toastMeg = Object.keys(validObject).map(key => {
            return validObject[key][0].message
          })

          Toast(toastMeg[0]);
        }
      });
    },
    onCancel() {
      this.$router.replace({
        path: "/admin/card",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.addCardMain {
  //padding: 0.2667rem 0.4rem;
  min-height: 100%;
  background-color: #F5F5F6;


  .form-content {
    margin-bottom: 0.3rem;

    .no-required {
      ::v-deep .el-form-item__label {
        padding-left: 0.301rem;
      }
    }
    ::v-deep .el-form-item__label {
      width: 1.8rem;
      text-align: left;
    }


    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 0;

        &:last-child {
          border-bottom: 0 !important;
        }
      }
    }
  }
}
</style>
